import { render, staticRenderFns } from "./EddSettings.vue?vue&type=template&id=8d925e82&"
import script from "./EddSettings.vue?vue&type=script&lang=js&"
export * from "./EddSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports